"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var medicalcode_chip_1 = require("../../../transacton-code/medicalcode-chip");
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var conditional_1 = require("../../../conditional/conditional");
var editorIssues = __importStar(require("../../../common/editor-issues"));
var getValueAtPath = ((ui_common_1.workBench === null || ui_common_1.workBench === void 0 ? void 0 : ui_common_1.workBench.pathUtils) || {}).getValueAtPath;
var CodeFieldComponent = function (_a) {
    var _b, _c, _d;
    var chipProps = _a.chipProps, field = _a.field, value = _a.value, _e = _a.classNamesMedicalCodeChip, classNamesMedicalCodeChip = _e === void 0 ? [] : _e;
    var getDefaultChipProps = function () {
        var _a;
        if (!field || !value)
            return undefined;
        return {
            code: getValueAtPath(value, field.path),
            codeType: field.codeType,
            editable: !value['original'],
            sequence: 0,
            isDraggable: false,
            onDrop: function () { },
            handleCodeDelete: function () { var _a; return (_a = field === null || field === void 0 ? void 0 : field.onCodeDelete) === null || _a === void 0 ? void 0 : _a.call(field, value); },
            description: (_a = value['description']) !== null && _a !== void 0 ? _a : undefined
        };
    };
    var computedChipProps = chipProps || getDefaultChipProps();
    if (!computedChipProps)
        return null; // Render nothing if props are invalid
    var description = computedChipProps.description || 'No code description available';
    var popoverModifiers = {
        name: 'offset',
        options: {
            offset: [0, 20] // Adjust horizontal and vertical offset
        }
    };
    var errorMessages = ((_b = computedChipProps === null || computedChipProps === void 0 ? void 0 : computedChipProps.codeEdits) === null || _b === void 0 ? void 0 : _b[computedChipProps.code])
        ? editorIssues.formatEditGroup(computedChipProps === null || computedChipProps === void 0 ? void 0 : computedChipProps.codeEdits[computedChipProps.code], 0)
        : false;
    // controlling this manually so that the popover content will unmount properly when closed
    // otherwise it creates space in the DOM when not visible
    var _f = __read((0, react_1.useState)(false), 2), isHovered = _f[0], setIsHovered = _f[1];
    var handleMouseEnter = function () { return setIsHovered(true); };
    var handleMouseLeave = function () { return setIsHovered(false); };
    return ((0, jsx_runtime_1.jsxs)(react_2.Popover, __assign({ trigger: "hover", placement: "right", flip: true, modifiers: [popoverModifiers], isOpen: isHovered, onOpen: handleMouseEnter, onClose: handleMouseLeave }, { children: [(0, jsx_runtime_1.jsx)(react_2.PopoverTrigger, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])((_c = field === null || field === void 0 ? void 0 : field.classNames) !== null && _c !== void 0 ? _c : ''), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: (0, jsx_runtime_1.jsx)(medicalcode_chip_1.MedicalCodeChip, __assign({}, computedChipProps, { classNames: classNamesMedicalCodeChip })) })) }), (0, jsx_runtime_1.jsx)(react_2.Portal, { children: isHovered && ( //only take up space if it's showing
                (0, jsx_runtime_1.jsxs)(react_2.PopoverContent, { children: [(0, jsx_runtime_1.jsx)(react_2.PopoverArrow, {}), (0, jsx_runtime_1.jsx)(react_2.PopoverBody, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "code-popover-body" }, { children: [(0, jsx_runtime_1.jsx)("b", { children: ui_common_1.objectUtils.capitalize(computedChipProps.codeType) }), (0, jsx_runtime_1.jsx)(medicalcode_chip_1.MedicalCodeChip, __assign({}, computedChipProps, { editable: false })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "code-description" }, { children: description })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: ((_d = computedChipProps.evidence) === null || _d === void 0 ? void 0 : _d.length) > 0 }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "indicator" }, { children: "cmx" })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: !!errorMessages }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-artifacts message-wrap" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-artifacts col-messages" }, { children: errorMessages })) })) }))] })) })] })) })] })));
};
CodeFieldComponent.defaultProps = {
    classNamesMedicalCodeChip: []
};
exports["default"] = CodeFieldComponent;
//# sourceMappingURL=code-field-component.js.map